import React from 'react';
import { Box, SkeletonLine, SkeletonCircle } from '@wix/design-system';
export const LoadingState = () => /*#__PURE__*/React.createElement(Box, {
  direction: "vertical",
  padding: "4px 0"
}, /*#__PURE__*/React.createElement(Box, {
  direction: "horizontal",
  align: "space-between",
  verticalAlign: "middle"
}, /*#__PURE__*/React.createElement(SkeletonLine, {
  width: "45%"
}), /*#__PURE__*/React.createElement(SkeletonCircle, {
  diameter: "18px"
})), /*#__PURE__*/React.createElement(SkeletonLine, {
  width: "100%",
  marginTop: "11px"
}));
//# sourceMappingURL=LoadingState.js.map